__turbopack_context__.v({
  "chevron": "drawer-module__ZYUkmG__chevron",
  "closeButton": "drawer-module__ZYUkmG__closeButton",
  "drawer": "drawer-module__ZYUkmG__drawer",
  "drawerHeader": "drawer-module__ZYUkmG__drawerHeader",
  "dropdown": "drawer-module__ZYUkmG__dropdown",
  "dropdownItem": "drawer-module__ZYUkmG__dropdownItem",
  "dropdownItemCategory": "drawer-module__ZYUkmG__dropdownItemCategory",
  "dropdownItemExternal": "drawer-module__ZYUkmG__dropdownItemExternal",
  "dropdownItemLogo": "drawer-module__ZYUkmG__dropdownItemLogo",
  "dropdownItemLogoImg": "drawer-module__ZYUkmG__dropdownItemLogoImg",
  "dropdownItemLogoSvg": "drawer-module__ZYUkmG__dropdownItemLogoSvg",
  "dropdownItemResource": "drawer-module__ZYUkmG__dropdownItemResource",
  "dropdownItemResourceLabel": "drawer-module__ZYUkmG__dropdownItemResourceLabel",
  "hamburger": "drawer-module__ZYUkmG__hamburger",
  "hamburgerLine": "drawer-module__ZYUkmG__hamburgerLine",
  "icon": "drawer-module__ZYUkmG__icon",
  "logoLink": "drawer-module__ZYUkmG__logoLink",
  "logoPreload": "drawer-module__ZYUkmG__logoPreload",
  "nav": "drawer-module__ZYUkmG__nav",
  "navLink": "drawer-module__ZYUkmG__navLink",
  "navLinkDisabled": "drawer-module__ZYUkmG__navLinkDisabled",
  "navLinkText": "drawer-module__ZYUkmG__navLinkText",
  "navLinkUnderline": "drawer-module__ZYUkmG__navLinkUnderline",
  "overlay": "drawer-module__ZYUkmG__overlay",
  "themeToggleContainer": "drawer-module__ZYUkmG__themeToggleContainer",
});
